// this would be content.js, but I already have and don't want to convert
// content.coffee

import { httpPOST, json } from './utils.js';
import { toID } from '../reducers/utils.js';
import { getContent } from './content';
import { fetchSection } from './section';
import { newNotification, updateNotification } from './notifications.js';
import { genKey } from 'actions/notifications';
import { ICONS } from '../const';

const importNewContent = (sections, resource_uri) => dispatch => {
    dispatch(getContent(toID(resource_uri))).then(content => {
        sections.forEach(id => dispatch(fetchSection(id)));
    });
};

export const uploadMaterial = options => dispatch => {
    const { fileElement, sections, title, description, tos } = options;
    const sectionIds = sections.join(',');
    const key = genKey();

    dispatch(
        newNotification(fileElement.files[0].name, 'Uploading...', {
            key,
            dismissable: false,
        })
    );

    httpPOST('/api/v3/repository/upload/', null, {
        formData: {
            upload_file: fileElement.files[0],
            apply_to_courses: sectionIds,
            upload_title: title,
            upload_description: description,
            terms_of_service: tos,
        },
        headers: {
            // The server claims to return `text/plain`, but it's actually JSON
            Accept: '*/*',
        },
    })
        .then(json)
        .then(({ resource_uri }) => {
            dispatch(
                updateNotification(key, {
                    timeout: 3000,
                    text:
                        'The file is uploaded and queued for processing. It will be available within 1 hour.',
                })
            );
            dispatch(importNewContent(sections, resource_uri));
        })
        .catch(error => {
            dispatch(
                newNotification('Error', 'Please try uploading again', {
                    icon: ICONS.FAIL,
                    dismissable: true,
                })
            );
        });
};

export const createLink = ({
    title,
    url,
    sections,
    description,
    embed,
}) => dispatch => {
    httpPOST('/api/v3/repository/externallink/', null, {
        formData: {
            title,
            url,
            description,
            embed,
            sections: sections.join(','),
        },
    })
        .then(json)
        .then(response => {
            dispatch(
                newNotification('Link created', `Created link ${title}`, {
                    icon: ICONS.SUCCESS,
                })
            );
            response.objects.map(({ resource_uri }) =>
                dispatch(importNewContent(sections, resource_uri))
            );
        })
        .catch(() => {
            dispatch(
                newNotification(
                    'Error',
                    'Please try submitting your link again',
                    {
                        icon: ICONS.FAIL,
                        dismissable: true,
                    }
                )
            );
        });
};



// WEBPACK FOOTER //
// ./src/actions/material.js